"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CurrentUserContext", {
  enumerable: true,
  get: function get() {
    return _UserContext.CurrentUserContext;
  }
});
Object.defineProperty(exports, "UserModel", {
  enumerable: true,
  get: function get() {
    return _UserContext.UserModel;
  }
});
Object.defineProperty(exports, "UserPermissionContext", {
  enumerable: true,
  get: function get() {
    return _UserContext.UserPermissionContext;
  }
});
Object.defineProperty(exports, "UserPermissions", {
  enumerable: true,
  get: function get() {
    return _UserContext.UserPermissions;
  }
});
Object.defineProperty(exports, "userModel", {
  enumerable: true,
  get: function get() {
    return _UserContext.userModel;
  }
});
Object.defineProperty(exports, "userPermissionsModel", {
  enumerable: true,
  get: function get() {
    return _UserContext.userPermissionsModel;
  }
});

var _UserContext = require("@insided/shared/services/UserContext");